module.exports = __webpack_public_path__ + "img/M1_BK_08.76b505b1.png";